import React from "react"
import {
  Box,
  Button,
  HStack,
  Stack,
} from "@chakra-ui/react"
import { Control, useFieldArray } from "react-hook-form"
import { v4 as uuidv4 } from "uuid"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"
import { PassBuilderFieldTitle } from "./PassBuilderTypography"
import PassBuilderBackSectionRow from "./PassBuilderBackSectionRow"
import {
  PASS_BUILDER_BACK_COL_GAP,
  PASS_BUILDER_BACK_DELETE_COL_WIDTH,
  PASS_BUILDER_BACK_LABEL_WIDTH,
  PASS_BUILDER_BACK_TYPE_WIDTH,
  PASS_BUILDER_BACK_VALUE_WIDTH,
} from "./passBuilderTokens"

type Props = {
  control: Control<WalletPassBuilderFormValues>
}

const PassBuilderBackSections = ({ control }: Props) => {
  const { fields, append, remove } = useFieldArray({
    control: control as any,
    name: "backSections",
  })

  const handleAdd = () => {
    append({
      id: uuidv4(),
      type: "",
      label: "",
      value: "",
    })
  }

  return (
    <Box>
      {fields.length > 0 && (
        <HStack
          spacing={PASS_BUILDER_BACK_COL_GAP}
          alignItems="flex-end"
          mb={2}
        >
          <Box w={PASS_BUILDER_BACK_TYPE_WIDTH} flexShrink={0} />
          <Box w={PASS_BUILDER_BACK_LABEL_WIDTH}>
            <PassBuilderFieldTitle mb={0}>Label</PassBuilderFieldTitle>
          </Box>
          <Box w={PASS_BUILDER_BACK_VALUE_WIDTH}>
            <PassBuilderFieldTitle mb={0}>Value / Content</PassBuilderFieldTitle>
          </Box>
          <Box w={PASS_BUILDER_BACK_DELETE_COL_WIDTH} flexShrink={0} />
        </HStack>
      )}
      <Stack spacing={3}>
        {fields.map((field, index) => (
          <PassBuilderBackSectionRow
            key={field.id}
            index={index}
            control={control}
            onRemove={remove}
          />
        ))}
      </Stack>
      <Box mt={4}>
        <Button
          size="sm"
          variant="outline"
          onClick={handleAdd}
          h="38px"
          minW="132px"
          bg="white"
          borderColor="blue.500"
          color="blue.500"
        >
          Add Section
        </Button>
      </Box>
    </Box>
  )
}

export default PassBuilderBackSections
